import React, { ReactElement } from 'react';

import { IParentProps } from '../../shared/types/IParentProps';

export function OzProductCardHero (props: IParentProps<ReactElement>): ReactElement {
    const { children }: IParentProps<ReactElement> = props;

    if (children.type !== 'img') {
        throw new Error('OzProductCard.Hero must contain only a single img tag');
    }

    return <div className="aspect-video relative">{children}</div>;
}
